export const DEFAULT_INSIGHT_CURRENCY = "EUR";

/** Keeps organization currency display resilient to absent or malformed legacy values. */
export function insightCurrency(currencyCode?: string): string {
    const candidate = currencyCode?.trim().toUpperCase() || DEFAULT_INSIGHT_CURRENCY;
    try {
        new Intl.NumberFormat("en", {style: "currency", currency: candidate}).format(0);
        return candidate;
    } catch {
        return DEFAULT_INSIGHT_CURRENCY;
    }
}

export function insightCurrencySymbol(currency: string, locale?: string): string {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: insightCurrency(currency),
        currencyDisplay: "narrowSymbol",
    }).formatToParts(0).find(part => part.type === "currency")?.value ?? insightCurrency(currency);
}
